<script setup lang="ts">
import { TabsContent, type TabsContentProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends ClassProps, TabsContentProps {}
const props = defineProps<Props>();

const delegatedProps = useDelegatedProps(props);
</script>

<template>
	<TabsContent :class="cn('mt-1 p-2', props.class)" v-bind="delegatedProps">
		<slot />
	</TabsContent>
</template>
